import * as React from "react";
import { singleton } from "../../../logic/singleton";
const RenderCompletionCallback = React.createContext(() => {
});
export default singleton("views.components.widgets.RenderCompletionCallback", () => RenderCompletionCallback);
